export default __webpack_public_path__ + "profile@2x.4d32ff50.png";